export default function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true ||
    document.referrer.startsWith("android-app://")
  );
}

// for mobile view in crome browser

// export default function isStandalone() {
//   return (
//     window.innerWidth <= 768 ||
//     /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent)
//   );
// }
